import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";
import { ClientCustomService } from "../service";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FilePond } from "react-filepond";
import { ActualFileObject, FilePondFile } from "filepond";
import { t } from "i18next";
import { EmptyState } from "../../../shared/components/EmptyState";
import { Button } from "react-bootstrap";
import { ConfirmDelete } from "../../../shared/components/ConfirmDelete";

const ClientCustomMediaById = () => {
  const { id, variationId } = useParams();
  const [images, setImages] = useState<any>([]);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [files, setFiles] = useState<ActualFileObject[]>([]);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [selectedImage, setSelectedImage] = useState({} as any);
  const navigate = useNavigate();
  useEffect(() => {
    const div = document.querySelector("div.row.mx-0.w-100");
    if (div) {
      div.classList.remove("row", "mx-0", "w-100");
    }

    const pageContent = document.querySelector(".page-content") as HTMLElement;
    const originalPaddingLeft = pageContent?.style.paddingLeft;
    const originalPaddingRight = pageContent?.style.paddingRight;

    if (pageContent) {
      pageContent.style.setProperty("padding-left", "0", "important");
      pageContent.style.setProperty("padding-right", "0", "important");
    }

    return () => {
      if (div) {
        div.classList.add("row", "mx-0", "w-100");
      }
      if (pageContent) {
        if (originalPaddingLeft) {
          pageContent.style.setProperty(
            "padding-left",
            originalPaddingLeft,
            "important"
          );
        } else {
          pageContent.style.removeProperty("padding-left");
        }

        if (originalPaddingRight) {
          pageContent.style.setProperty(
            "padding-right",
            originalPaddingRight,
            "important"
          );
        } else {
          pageContent.style.removeProperty("padding-right");
        }
      }
    };
  }, []);
  const handleLabelChange = (index: number, value: string) => {
    setImages((prevImages: any) =>
      prevImages.map((img: any, i: number) =>
        i === index ? { ...img, label: value } : img
      )
    );
  };
  useEffect(() => {
    ClientCustomService.getSemgProductImages(id as any, variationId)
      .then((response: any) => {
        const imagesWithLabels = (response?.images || []).map((img: any) => ({
          ...img,
          label: img.label ?? "",
        }));
        setImages(imagesWithLabels);
      })
      .catch((error: any) => ErrorToast(error));
  }, [id, variationId, triggerUpdate]);

  // reorder funkcija
  const handleDragEnd = (result: any) => {
    if (!result.destination) return;
    const reordered = Array.from(images);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setImages(reordered);

    ClientCustomService.setPositions(id, Number(variationId), {
      urls: reordered?.map((item: any) => item.url),
    })
      .then((response) => {
        // setTriggerUpdate((prev: boolean) => !prev);
        SuccessToast(`${t("toasts.successfully_updated")}`);
      })
      .catch((error) => ErrorToast(error));
  };
  const saveLabel = (event: any, index: number) => {
    event.preventDefault();
    ClientCustomService.updateProductImageLabelById(id, Number(variationId), {
      imageUrl: images[index].url,
      label: images[index].label,
    })
      .then((response) => {
        // navigate(-1);
        SuccessToast(`${t("toasts.successfully_updated")}`);
      })
      .catch((error) => ErrorToast(error));
  };
  const addImages = (event: any) => {
    event.preventDefault();
    const formData = new FormData();
    for (let i = 0; i < files?.length; i++) {
      formData.append("images", files[i]);
    }

    ClientCustomService.uploadImages(id, Number(variationId), formData)
      .then((response) => {
        setTriggerUpdate((prev: boolean) => !prev);
        setFiles([]);
        SuccessToast(`${t("toasts.successfully_added")}`);
      })
      .catch((error) => ErrorToast(error));
  };
  const deleteImageLogic = (urlImage: string) => {
    ClientCustomService.deleteImage(id, Number(variationId), {
      imageUrl: urlImage,
    })
      .then((response) => {
        setTriggerUpdate((prev: boolean) => !prev);
        SuccessToast(`${t("toasts.successfully_deleted")}`);
      })
      .catch((error) => ErrorToast(error));
  };
  return (
    <div className="card media-module">
      <div className="card-body">
        <ul
          className="nav nav-tabs-custom rounded card-header-tabs border-bottom-0 pb-5"
          role="tablist"
        >
          <li className="nav-item">
            <Link
              to={`/app/clients/semg/${id}/${variationId}`}
              role="tab"
              className="nav-link"
              aria-selected="true"
            >
              {t("manage.BASE_DATA")}
            </Link>
          </li>
          <li className="nav-item">
            <a
              href="/"
              role="tab"
              data-bs-toggle="tab"
              className="nav-link active"
              aria-selected="true"
            >
              {t("manage.MEDIA")}
            </a>
          </li>
        </ul>
        <div className="row d-flex">
          <div className="d-flex justify-content-end">
            <Button
              variant="primary"
              onClick={() => navigate("/app/clients/semg")}
              className="btn btn-primary d-flex align-items-center"
            >
              <i className="ri-arrow-left-line me-1" />
              {t("block.back")}
            </Button>
          </div>
        </div>
        <div className="row" style={{ minHeight: "110px" }}>
          <div className="col-3">
            <div className="">
              <FilePond
                files={files}
                allowReorder={true}
                allowMultiple={true}
                acceptedFileTypes={["image/*"]}
                onupdatefiles={(filesArr: FilePondFile[]) => {
                  setFiles(filesArr?.map((fileItem) => fileItem?.file));
                }}
                labelIdle={`${t("products.drag_and_drop")}`}
              />
              {files?.length > 0 && (
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-secondary "
                    onClick={(e: any) => addImages(e)}
                  >
                    {t("global.save")}
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="col-9">
            {images?.length > 0 ? (
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="images" direction="horizontal">
                  {(provided) => (
                    <div
                      className="d-flex flex-wrap position-relative"
                      style={{ overflow: "hidden" }}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {images?.map((img: any, index: number) => (
                        <Draggable
                          key={index.toString()}
                          draggableId={index.toString()}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              className="m-2"
                              style={{
                                width: "calc(50% - 16px)",
                                minWidth: 200,
                                ...provided.draggableProps.style,
                              }}
                            >
                              <div className="border rounded p-3 d-flex">
                                <div className="me-3">
                                  <img
                                    src={img?.url}
                                    alt={`Image ${img?.url}`}
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                                <div className="d-flex flex-column justify-content-between flex-grow-1">
                                  <div>
                                    <label htmlFor={`imageLabel-${img?.url}`}>
                                      {t("custom_client.image_label")}
                                    </label>
                                    <input
                                      id={`imageLabel-${index}`}
                                      type="text"
                                      value={img?.label ?? ""}
                                      placeholder="Image label"
                                      className="form-control"
                                      onChange={(e) =>
                                        handleLabelChange(index, e.target.value)
                                      }
                                    />
                                  </div>
                                  <div className="d-flex justify-content-between mt-2">
                                    <i
                                      className="ri-order-play-line"
                                      {...provided.dragHandleProps}
                                      style={{ fontSize: "22px" }}
                                    ></i>

                                    <button
                                      type="button"
                                      className="btn text-primary p-0"
                                      title="Save image"
                                      onClick={(e) => saveLabel(e, index)}
                                    >
                                      <i
                                        className="ri-save-3-line"
                                        style={{ fontSize: "22px" }}
                                      ></i>
                                    </button>

                                    <button
                                      type="button"
                                      className="btn text-danger p-0"
                                      title="Delete image"
                                      // onClick={(e) =>
                                      //   deleteImageLogic(e, img?.url)
                                      // }
                                      onClick={() => {
                                        setSelectedImage(img);
                                        handleShow();
                                      }}
                                    >
                                      <i
                                        className="ri-delete-bin-6-line"
                                        style={{ fontSize: "22px" }}
                                      ></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            ) : (
              <EmptyState />
            )}
          </div>
        </div>
      </div>
      <ConfirmDelete
        show={show}
        setShow={setShow}
        itemName={selectedImage?.url}
        deleteHandler={deleteImageLogic}
        selectedProduct={selectedImage}
        titlePage={"semg-media"}
      />
    </div>
  );
};

export default ClientCustomMediaById;
